import React,{Component} from 'react';

import './validationCode.scss';

import {checkValidaationSMS, sendValidationSMS} from '../../../../../redux/actions';

//assets
import closeIcon from 'assets/icons/close_icon.svg';
import {connect} from "react-redux";

class ValidationCode extends Component{

    constructor(props){
        super(props);

        this.state = {
            sendAgain:false,
            allValid:false,
            form:{
                first:false,
                second:false,
                third:false,
                fourth:false
            }
        }

        this.handleOnInput = this.handleOnInput.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.sendAgain = this.sendAgain.bind(this);
    }

    componentDidMount(){
        setTimeout(()=>{
            this.setState({sendAgain:true});
        },10000);
    }

    handleOnInput(e){
        if(e.target.previousSibling !== null){
            e.target.previousSibling.focus();
        }
        e.target.value = e.target.value.slice(0, 1);
        let new_state;
        if (e.target.value === '')
            new_state = {...this.state.form, [e.target.name]: false};
        else
            new_state = {...this.state.form, [e.target.name]: e.target.value};


        const form = new_state;
        let is_valid = true;
        for (let key in form) {
            if (form[key] === false)
                is_valid = false;
        }

        this.setState({form: new_state, allValid: is_valid});
    }


    handleOnSubmit(){
        const form = this.state.form;
        let payload = '';
        for (let key in form) {
            payload = payload.concat(form[key]);
        }

        if(this.state.allValid){
            this.props.checkValidaationSMS({code:payload, email:this.props.email});
        }
    }

    sendAgain(){
        const payload = this.props.personalDetails;

        this.props.sendValidationSMS({email:payload.email, phone:payload.phone});
    }

    render(){
        const validation = this.props.checkSMS;

        if(validation){
            this.props.onStepUp(1);
        }

        return(
            <section className={'validation_code'}>
                <img className='close_icon' src={closeIcon} alt='/' onClick={() => this.props.onClose()}/>
                <div className='head'>
                    <h2 className='title'>סמס עם קוד אימות בדרך אליכם</h2>
                    <span className='sub_title'>הכניסו אותו כאן</span>
                </div>
                <div className='code_form'>
                    <input type='number' onInput={event => this.handleOnInput(event)} className='input_num' name='fourth' tabIndex={4} />
                    <input type='number' onInput={event => this.handleOnInput(event)} className='input_num' name='third' tabIndex={3}/>
                    <input type='number' onInput={event => this.handleOnInput(event)} className='input_num' name='second' tabIndex={2}/>
                    <input type='number' onInput={event => this.handleOnInput(event)} className='input_num' name='first'  tabIndex={1}/>
                </div>
                <div className='submit_wrapper'>
                    <button className={'submit_btn ' + (!this.state.allValid ? 'disabled' : '')} onClick={this.handleOnSubmit}>המשך</button>
                    { this.state.sendAgain &&
                        <span className='send_span' onClick={this.sendAgain}>לא קיבלתי, שלחו שוב</span>
                    }
                </div>
            </section>
        )
    }
}

const mapStateToProps = store => {
    return {
        checkSMS: store.data.ValidSMS,
        personalDetails : store.data.OrderDetails,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        checkValidaationSMS:(payload) => dispatch(checkValidaationSMS(payload)),
        sendValidationSMS:(payload) => dispatch(sendValidationSMS(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(ValidationCode);